// eslint-disable-next-line import/prefer-default-export
export const MODAL_TITLE_TYPE = {
  SUCCESS: "success",
  ERROR: "warning",
  DEFAULT: "subtitle"
};
